import CommonAvatar from "@/modules/common/components/ui-kit/common-avatar";
import { Stack, Typography, useTheme } from "@mui/material";
import Color from "color";

interface UserNameTagProps {
  name: string;
  color?: string | null;
}
const UserNameTag = ({ name, color }: UserNameTagProps) => {
  const theme = useTheme();

  const colorObj = color ? new Color(color) : null;

  return (
    <Stack
      direction="row"
      spacing={theme.nawy.spacing.xxs}
      alignItems="center"
      justifyContent="center"
    >
      <CommonAvatar name={name} color={color} />
      <Typography
        color={
          colorObj
            ? colorObj.darken(0.5).toString()
            : theme.nawy.colors.semantic.text.primary
        }
        sx={{
          ...theme.nawy.typography.english.variants.body.md.semibold,
          textTransform: "capitalize",
        }}
      >
        {name}
      </Typography>
    </Stack>
  );
};

export default UserNameTag;
